import React, { useEffect, useRef, useState } from 'react';
import './AdBanner.css';

interface AdBannerProps {
  showAds: boolean;
  adSlot?: string;
  format?: 'auto' | 'rectangle' | 'horizontal' | 'vertical';
  className?: string;
}

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

let adCounter = 0;

export const AdBanner: React.FC<AdBannerProps> = ({ 
  showAds, 
  adSlot = '7731352951',
  format = 'auto',
  className = ''
}) => {
  const adRef = useRef<HTMLModElement>(null);
  const adId = useRef(`ad-${++adCounter}`);
  const [isMobile, setIsMobile] = useState(false);
  const [adLoaded, setAdLoaded] = useState(false);
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

  // 모바일 감지
  useEffect(() => {
    const checkMobile = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const mobileKeywords = ['mobile', 'android', 'iphone', 'ipad', 'ipod', 'blackberry', 'windows phone'];
      const isMobileDevice = mobileKeywords.some(keyword => userAgent.includes(keyword)) || window.innerWidth <= 768;
      setIsMobile(isMobileDevice);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    if (showAds && !isLocalhost && adRef.current && !adLoaded) {
      // 모바일에서는 더 긴 지연시간 적용
      const delay = isMobile ? 500 : 100;
      
      const timer = setTimeout(() => {
        try {
          if (adRef.current && !adRef.current.hasAttribute('data-adsbygoogle-status')) {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
            setAdLoaded(true);
            console.log(`AdSense 광고 로드 시도 (${isMobile ? '모바일' : '데스크톱'})`);
          }
        } catch (error) {
          console.error('AdSense error:', error);
        }
      }, delay);

      return () => clearTimeout(timer);
    }
  }, [showAds, isLocalhost, isMobile, adLoaded]);

  if (!showAds || isLocalhost) {
    return isLocalhost ? (
      <div className={`ad-banner ${className}`} style={{ minWidth: '320px', width: '100%', maxWidth: '728px', margin: '20px auto', padding: '20px', backgroundColor: '#f5f5f5', textAlign: 'center', border: '1px dashed #ccc' }}>
        <div style={{ color: '#666' }}>광고 영역 (개발 환경에서는 표시되지 않음)</div>
      </div>
    ) : null;
  }

  // 모바일과 데스크톱에 따른 스타일 조정
  const containerStyle = {
    minWidth: isMobile ? '300px' : '320px',
    width: '100%',
    maxWidth: isMobile ? '100%' : '728px',
    margin: isMobile ? '15px auto' : '20px auto',
    padding: isMobile ? '8px' : '10px'
  };

  const adStyle = {
    display: 'block',
    minWidth: isMobile ? '300px' : '320px',
    minHeight: isMobile ? '250px' : '100px',
    width: '100%'
  };

  return (
    <div className={`ad-banner ${className} ${isMobile ? 'mobile' : 'desktop'}`} style={containerStyle}>
      <div className="ad-label">광고</div>
      <ins
        ref={adRef}
        key={adId.current}
        className="adsbygoogle"
        style={adStyle}
        data-ad-client="ca-pub-1466307496190391"
        data-ad-slot="7731352951"
        data-ad-format={isMobile ? 'rectangle' : 'auto'}
        data-full-width-responsive="true"
      />
      {!adLoaded && showAds && !isLocalhost && (
        <div style={{ 
          color: '#999', 
          fontSize: '12px', 
          marginTop: '10px',
          display: isMobile ? 'block' : 'none'
        }}>
          광고 로딩 중...
        </div>
      )}
    </div>
  );
};

export default AdBanner;